import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Column } from '@/components/layout'
import RecaptchaTerms from '@/components/common/RecaptchaTerms'

import FormBoxLogo from './FormBoxLogo'
import styles from './SignUp.module.scss'

export default function SignUpLayout({
  split = true,
  children,
  sideContent,
  ...rest
}) {
  useEffect(() => {
    if (split) {
      const body = document.querySelector('body')
      body?.classList.add('sign-up-split')

      return () => body?.classList.remove('sign-up-split')
    }
    return undefined
  }, [split])
  return (
    <div className={split ? styles.split : styles.wrapper}>
      <Column
        className={styles.formHolder}
        justifyCenter={!split}
        size={split ? 40 : undefined}
        {...rest}
      >
        <FormBoxLogo />
        {children}
        <RecaptchaTerms textProps={{ center: true }} />
      </Column>
      {split && sideContent && (
        <Column justifyCenter size={60}>
          {sideContent}
        </Column>
      )}
    </div>
  )
}

SignUpLayout.propTypes = {
  split: PropTypes.bool,
  children: PropTypes.node.isRequired,
  sideContent: PropTypes.node,
}
